import * as Sentry from '@sentry/react'

if (import.meta.env.PROD) {
	Sentry.init({
		dsn: 'https://56f894a67acffdef9f0f56e361c5a0e6@o4510685721919488.ingest.de.sentry.io/4510685725720656',
		// Setting this option to true will send default PII data to Sentry.
		// For example, automatic IP address collection on events
		sendDefaultPii: true,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
			}),
		],

		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: [
			'localhost',
			'https://dev--ugc-marketplace.netlify.app',
			'https://ugc-marketplace.netlify.app',
		],

		// Session Replay
		replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
		// Enable logs to be sent to Sentry
		enableLogs: true,
	})
}
